import { combineEpics, ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { catchError, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators'

import { INCIDENT_TYPE } from '../../constants'
import { fetchIncident } from '../actions'
import { ATO_STATES } from '../constants'

import {
  changeAtoAssigneesError,
  changeAtoAssigneesSuccess,
  changeIncidentStateError,
  changeIncidentStateSuccess,
} from './actions'
import { CHANGE_ASSIGNEES_ASYNC, CHANGE_INCIDENT_STATE_REQUEST_ASYNC } from './constants'

const changeIncidentStateEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(CHANGE_INCIDENT_STATE_REQUEST_ASYNC.INITIATE),
    mergeMap((action) => {
      const { incidentId, newState } = action.payload

      return api.resolutionCenter
        .changeAtoIncidentState(
          incidentId,
          newState,
          newState === ATO_STATES.COMPROMISED &&
            Object.keys(state$.value.resolutioncenter.atoIncidentHeader.remediationActions)
              .filter((e) => state$.value.resolutioncenter.atoIncidentHeader.remediationActions[e])
              .map((e) => Number(e))
        )
        .pipe(
          mergeMap(() =>
            from([
              changeIncidentStateSuccess(newState),
              fetchIncident(incidentId, INCIDENT_TYPE.ATO),
            ])
          ),
          catchError((error) => of(epicsErrorHandler(changeIncidentStateError, error))),
          takeUntil(action$.pipe(ofType(CHANGE_INCIDENT_STATE_REQUEST_ASYNC.CANCEL)))
        )
    })
  )

const changeAssigneeEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(CHANGE_ASSIGNEES_ASYNC.INITIATE),
    switchMap((action) =>
      api.resolutionCenter
        .changeAtoAssignee(action.payload.incidentId, {
          assignee_id: action.payload.assigneeId,
        })
        .pipe(
          map((response) => changeAtoAssigneesSuccess(response)),
          catchError((error) => of(epicsErrorHandler(changeAtoAssigneesError, error))),
          takeUntil(action$.pipe(ofType(CHANGE_ASSIGNEES_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(changeIncidentStateEpic, changeAssigneeEpic)
